import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var EShapedIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M7.2 4.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM7 8h4v8.764l.007.117A1 1 0 0013 16.764V8h4v12l.007.117A1 1 0 0019 20V7l-.007-.117A1 1 0 0018 6H6l-.117.007A1 1 0 005 7v13l.007.117A1 1 0 006 21l.117-.007A1 1 0 007 20V8zM3.1 11.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2z"
                        }),
                        _jsx("path", {
                            d: "M8.94 11.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM21.91 10.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM15.1 11.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM4.2 13.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM8.94 14.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM21.91 13.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM15.1 14.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM4.2 16.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM8.94 17.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM21.91 16.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM15.1 17.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM4.2 19.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM8.94 20.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM21.91 19.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM15.1 20.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM10.2 4.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM12.1 5.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM16.2 4.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM18.1 5.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2z"
                        })
                    ]
                })
            })
        ]
    });
};
EShapedIcon.isCarinaIcon = true;
export default EShapedIcon;
